import Cookies from 'js-cookie';
import { getCurrentCookieDomain } from '@/components/CookieUtils';

export interface ConsentData {
  basic: boolean;
  useful: boolean;
  analytics: boolean;
  marketing: boolean;
}

export const consentCookieName = 'gdprconsent';
// make sure to call this before store consentdata to cookie ( Not legal to store jsondata in cookie)
const makeStringForCookie = (consentData: ConsentData) => {
  const json = JSON.stringify(consentData);
  // will remove double quotes from string
  return json.replace(/"([^"]+)":/g, '$1:');
};

// use this to convert cookie string to consent object
const makeConsentDataObjectFromString = (cookieStringValue: string) => {
  // will add double quotes back so JSON.parse will work
  return JSON.parse(
    cookieStringValue.replace(/(\{|,)\s*(.+?)\s*:/g, '$1 "$2":')
  );
};

export const isConsentGiven = () => {
  return Cookies.get(consentCookieName) ? true : false;
};

export const hasMarketingConsent = () => {
  // Check if we have a consent cookie
  const consentCookie = Cookies.get(consentCookieName);
  if (consentCookie) {
    const consentCookieJson = makeConsentDataObjectFromString(consentCookie);
    // contains true if user has given consent, false if not.
    return consentCookieJson.marketing;
  }
  // Consent is enabled but user has not given reply (we can not show marketing content)
  return false;
};

// Check if skagenWeb is in simple mode
export const isSimpleMode = () => {
  return window.location.search.includes('Simple');
};

// Check if skagenWeb is in app mode (used for app)
export const isAppMode = () => {
  return window.location.search.includes('app=true');
};

export const getConsent = () => {
  if (isSimpleMode() || isAppMode()) {
    return {
      basic: true,
      useful: true,
      analytics: true,
      marketing: true,
    };
  }
  const consentCookie = Cookies.get(consentCookieName);
  if (consentCookie) {
    return makeConsentDataObjectFromString(consentCookie);
  }
  // We have no reply on consent ( Default consent is everything off)
  return {
    basic: true,
    useful: false,
    analytics: false,
    marketing: false,
  };
};

export const saveConsent = (consentData: ConsentData) => {
  const domain = getCurrentCookieDomain(window.location.hostname);
  const consentDataAsString = makeStringForCookie(consentData);
  Cookies.set(consentCookieName, consentDataAsString, {
    expires: 365,
    domain,
    sameSite: 'Lax',
  });
  return true;
};
